import * as T from './types'

export default {
    [T.SET_PRODUCT_LIST](state, list) {
        state.list = list
    },
    [T.SET_PRODUCT_ITEM](state, item) {
        state.detail = item
    },
    [T.SET_PRODUCT_CRED_LIST](state, list) {
        state.credList = list
    },
    [T.DELETE_PRODUCT_ITEM](state, id) {
        const index = state.list.findIndex(item => item.id === id)
        if (index < 0) return
        state.list.splice(index, 1)
    },
    [T.UPDATE_PRODUCT_ITEM](state, item) {
        if (state.detail.id === item.id) {
            state.detail = { ...state.detail, ...item }
        }

        const index = state.list.findIndex(i => i.id === item.id)
        if (index < 0) return
        state.list.splice(index, 1, {
            ...state.list[index],
            ...item
        })
    },
    [T.ADD_PRODUCT_CRED_ITEM](state, item) {
        state.credList.unshift({ ...item })
    },
    [T.UPDATE_PRODUCT_CRED_ITEM](state, item) {
        const index = state.credList.findIndex(cred => cred.id === item.id)
        if (index < 0) return
        state.credList.splice(index, 1, {
            ...state.credList[index],
            ...item
        })
    },
    [T.DELETE_PRODUCT_CRED_ITEM](state, id) {
        const index = state.credList.findIndex(cred => cred.id === id)
        if (index < 0) return
        state.credList.splice(index, 1)
    }
}
